import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DownloadIcon from '@mui/icons-material/Download';
import {Grid, SxProps, Typography, useTheme} from '@mui/material';

import {EmpionButton} from '../../../../../../components/EmpionButton/EmpionButton';
import {useTrackingEvents} from '../../../../../../hooks/useTrackingEvents';
import {empionGreen} from '../../../../../../layouts/theme/EmpionColors';
import {AppConfig} from '../../../../../../lib/AppConfig';
import {TrackingEvents} from '../../../../../../types/TrackingEvents';

interface PageHeaderProps {
  daysLeft: number | null;
  pdfUrl?: string;
}

export default function PageHeader({daysLeft, pdfUrl}: PageHeaderProps) {
  const {t} = useTranslation();
  const theme = useTheme();
  const {Version, Action, Category} = TrackingEvents;
  const {eventAttributes} = useTrackingEvents({
    version: Version.v0,
    action: Action.CulturalAnalysesPdfDownloaded,
    category: Category.Company,
    payload: {},
  });

  const linkStyles: SxProps = {
    marginTop: '8px',
    color: theme.palette.mode === 'dark' ? empionGreen[40] : empionGreen[700],
    verticalAlign: 'middle',
  };

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: {xs: '0px', sm: '16px'},
        marginBottom: 4,
      }}
    >
      <Grid item>
        <Typography variant='h1'>{t('companyCultureDashboard.title')}</Typography>
      </Grid>
      {daysLeft && daysLeft >= 0 && (
        <Link to={AppConfig.COMPANY_ADMIN_CULTURE_SURVEYS_PATH} style={{textDecoration: 'none'}}>
          <Grid container item sx={{display: 'flex', alignItems: 'center'}}>
            <Typography variant='body1' sx={{...linkStyles}}>
              {t('companySurveys.header.upcoming', {
                surveyType: t('companySurveys.shared.cultureSurvey'),
                daysLeft: daysLeft,
              })}
              <ArrowForwardIosIcon sx={{fontSize: '1rem', position: 'relative', top: '-4px', ml: 1, ...linkStyles}} />
            </Typography>
          </Grid>
        </Link>
      )}
      <Grid item xs />
      {pdfUrl && (
        <Grid item>
          <EmpionButton
            {...eventAttributes}
            hoverBackgroundColor={empionGreen[500]}
            sx={{
              backgroundColor: empionGreen[700],
            }}
            href={pdfUrl}
            disabled={!pdfUrl}
          >
            <DownloadIcon />
            {t('companyCultureDashboard.downloadReport')}
          </EmpionButton>
        </Grid>
      )}
    </Grid>
  );
}
